import React from 'react';
import PropTypes from 'prop-types';

import './User.scss';
import { User } from '../../common/types/types';

interface UserRendererProps {
 user: User;
 withoutPhoto?: boolean;
}

export default class UserRenderer extends React.Component<UserRendererProps> {
    static propTypes = {
        user: PropTypes.object.isRequired,
        withoutPhoto: PropTypes.bool
    };

    render() {
        let {firstname, surname, email, name, picture} = this.props.user;

        let visibleName = firstname || surname ? `${firstname || ''} ${surname || ''}`.trim() : name || '';

        visibleName = visibleName || '-';

        return (
            <div className="UserRenderer">
                { this.props.withoutPhoto
                    ? null
                    : <img className="profilePicture" src={picture} />
                }
                {visibleName}
                {email ? <span>&nbsp;&lt;{email}&gt;</span> : null}
            </div>
        );
    }
}
